import { SectionListQuery } from '__generated__/graphql/legacy/graphql';

import { useQuery } from '@apollo/client';

import { useCommunityContext } from 'components/CommunityContext';
import { FONTS } from 'components/FontProvider';

import { SECTION_QUERY } from 'schema/Section/queries';

interface Space {
  value: string;
  label: string;
}

const useSpacesList = () => {
  const { community } = useCommunityContext();
  const { data } = useQuery<SectionListQuery>(SECTION_QUERY, {
    variables: { communityId: community.id },
  });

  const communitySectionsEdges = data?.community?.communitySections?.edges;

  let spacesList: Space[] = [];

  if (communitySectionsEdges && communitySectionsEdges[0]?.node?.communitySpaces?.edges) {
    const spaces = communitySectionsEdges[0]?.node?.communitySpaces?.edges?.map((edge) => {
      return {
        value: edge?.node?.id || '',
        label: edge?.node?.name || '',
        dangerousFontFamily: `"${FONTS[community.font]}"`, // TODO: Remove this after Chalk fixes option theming
      };
    });
    spacesList = [...spacesList, ...spaces];
  }

  return spacesList;
};

export default useSpacesList;
